module.exports = require('./lib');


/*****************
 ** WEBPACK FOOTER
 ** ./~/react-highlight/index.js
 ** module id = 682
 ** module chunks = 0
 **/